import React, { useState } from 'react'
import axios from 'axios'
import { useRouter } from 'next/router'

import NarrowContainer from 'containers/NarrowContainer'

import Button from 'components/Button'
import FormattedMessage from 'components/FormattedMessage'
import Hint from 'components/Hint'
import Form from 'components/Form'
import FormItem from 'components/Form/Item'
import PasswordInput from 'components/Form/Input/Password'

import './index.less'

const ChangePassword = () => {
  const router = useRouter()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState()

  const submitHandler = (values) => {
    setIsSubmitting(true)
    setErrors(null)

    axios.put('/password.json', {
      user: {
        password: values.password,
        password_confirmation: values.passwordConfirmation,
        reset_password_token: router.query.reset_password_token,
      },
    })
      .then((result) => {
        window.location.href = '/providers'
      })
      .catch((error) => {
        setIsSubmitting(false)
        setErrors(error.response.data.errors)
      })
  }

  return (
    <NarrowContainer className="users users--change-password simple-form-layout">
      <h1 className="simple-form-layout__title">
        <FormattedMessage id="users.changePassword.title" />
      </h1>

      {errors && (
        <Hint
          variant="error"
          modifiers={['bold']}
          className="simple-form-layout__hint"
        >
          {Object.keys(errors).map((key) => (
            <div key={key}>{errors[key][0]}</div>
          ))}
        </Hint>
      )}

      <Form onSubmit={submitHandler}>
        <FormItem
          name="password"
          label={<FormattedMessage id="users.changePassword.password" />}
          className="simple-form-layout__item"
        >
          <PasswordInput
            name="password"
            rules={{ required: <FormattedMessage id="errors.empty" /> }}
            className="simple-form-layout__item__input"
            autoComplete="new-password"
          />
        </FormItem>

        <FormItem
          name="passwordConfirmation"
          label={<FormattedMessage id="users.changePassword.passwordConfirmation" />}
          className="simple-form-layout__item"
        >
          <PasswordInput
            name="passwordConfirmation"
            rules={{ required: <FormattedMessage id="errors.empty" /> }}
            className="simple-form-layout__item__input"
            autoComplete="new-password"
          />
        </FormItem>

        <FormItem className="simple-form-layout__item simple-form-layout__item--submit">
          <Button
            translationKey="users.changePassword.submit"
            type="primary"
            size="large"
            htmlType="submit"
            className="ant-btn--with-border-radius-large ant-btn--brand-font"
            disabled={isSubmitting}
          />
        </FormItem>
      </Form>

      <div className="simple-form-layout__footer">
        <FormattedMessage
          id="users.requestPassword.alreadyHavePassword"
          values={{ login: (chunks) => <a className="link" href="/login">{chunks}</a> }}
        />
      </div>
    </NarrowContainer>
  )
}

export default ChangePassword
